import React from 'react';
import Form from 'react-bootstrap/Form';
import Select, { MultiValue, StylesConfig } from 'react-select';

interface OpcaoSelect {
  value: string;
  label: string;
}

interface BarraDeFiltrosProps {
  busca: string;
  onBuscaChange: (v: string) => void;
  ufsDisponiveis: string[];
  ufsSelecionadas: string[];
  onUfsChange: (v: string[]) => void;
  subsistemasDisponiveis: string[];
  subsistemasSelecionados: string[];
  onSubsistemasChange: (v: string[]) => void;
  conjuntosDisponiveis: string[];
  conjuntosSelecionados: string[];
  onConjuntosChange: (v: string[]) => void;
}

// react-select altera o tamanho minimo padrao; aqui igualamos a altura
// ao input search do Bootstrap (calc(1.5em + 0.75rem + 2px)) para o
// alinhamento horizontal nao quebrar.
//
// FE-LAYOUT-007 #5a: neutralizar o "x" vermelho do multiValueRemove
// (default do react-select em hover). Vermelho permanente = falso alarme
// para acao passiva (remover filtro). Cor inherit + sutil escurecimento
// em hover; padrao Material/Carbon/AntD.
const estilosSelect: StylesConfig<OpcaoSelect, true> = {
  control: (base) => ({
    ...base,
    minHeight: '38px',
    fontSize: '0.875rem',
  }),
  menu: (base) => ({ ...base, fontSize: '0.875rem', zIndex: 1060 }),
  multiValue: (base) => ({ ...base, fontSize: '0.8125rem' }),
  multiValueRemove: (base) => ({
    ...base,
    color: 'inherit',
    opacity: 0.6,
    ':hover': {
      backgroundColor: 'transparent',
      color: 'inherit',
      opacity: 1,
    },
  }),
};

function paraOpcoes(valores: string[]): OpcaoSelect[] {
  return valores.map((v) => ({ value: v, label: v }));
}

/**
 * Barra superior do modal SeletorUsinasEolicas. Comporta busca textual e
 * tres multi-selects populados dinamicamente a partir do dataset (sem
 * chamadas extras ao backend). Os valores unicos sao extraidos no
 * container pai e passados como `*Disponiveis`.
 */
export default function BarraDeFiltros({
  busca,
  onBuscaChange,
  ufsDisponiveis,
  ufsSelecionadas,
  onUfsChange,
  subsistemasDisponiveis,
  subsistemasSelecionados,
  onSubsistemasChange,
  conjuntosDisponiveis,
  conjuntosSelecionados,
  onConjuntosChange,
}: BarraDeFiltrosProps) {
  const handleMulti = (
    onChange: (v: string[]) => void,
  ) => (sel: MultiValue<OpcaoSelect>) => onChange(sel.map((o) => o.value));

  return (
    <div className="windx-seletor-usinas__filtros">
      <Form.Group className="windx-seletor-usinas__filtros-busca">
        <Form.Label className="visually-hidden" htmlFor="windx-usinas-busca">
          Buscar usinas
        </Form.Label>
        <Form.Control
          id="windx-usinas-busca"
          type="search"
          placeholder="Buscar nome, código ou CEG..."
          value={busca}
          onChange={(e) => onBuscaChange(e.target.value)}
          autoFocus
        />
      </Form.Group>
      <div className="windx-seletor-usinas__filtros-select">
        <Select<OpcaoSelect, true>
          isMulti
          inputId="windx-usinas-uf"
          placeholder="UF · todas"
          options={paraOpcoes(ufsDisponiveis)}
          value={paraOpcoes(ufsSelecionadas)}
          onChange={handleMulti(onUfsChange)}
          styles={estilosSelect}
          noOptionsMessage={() => 'Nenhuma UF'}
          aria-label="Filtrar por UF"
        />
      </div>
      <div className="windx-seletor-usinas__filtros-select">
        <Select<OpcaoSelect, true>
          isMulti
          inputId="windx-usinas-sub"
          placeholder="Subsistema · todos"
          options={paraOpcoes(subsistemasDisponiveis)}
          value={paraOpcoes(subsistemasSelecionados)}
          onChange={handleMulti(onSubsistemasChange)}
          styles={estilosSelect}
          noOptionsMessage={() => 'Nenhum subsistema'}
          aria-label="Filtrar por subsistema"
        />
      </div>
      <div className="windx-seletor-usinas__filtros-select">
        <Select<OpcaoSelect, true>
          isMulti
          inputId="windx-usinas-conjunto"
          placeholder="Conjunto · todos"
          options={paraOpcoes(conjuntosDisponiveis)}
          value={paraOpcoes(conjuntosSelecionados)}
          onChange={handleMulti(onConjuntosChange)}
          styles={estilosSelect}
          noOptionsMessage={() => 'Nenhum conjunto'}
          aria-label="Filtrar por conjunto"
        />
      </div>
    </div>
  );
}
